import {IPlayerState, PlayerActions} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";
import {music, sounds} from "../../shared/sounds";

export const playerInitialState: IPlayerState = {
    lives: 5,
    coins: 600,
    score: 0,
    levelsCompleted: 0,
    bonuses: Object.create(null),
    lastLiveIncrementTimestamp: 0,
    settings: {
        music: true,
        sounds: true,
        shortcutCreated: false,
    }
};

export const playerReducer : Reducer<IPlayerState, PlayerActions> = (state = playerInitialState, action) => {
    switch (action.type) {
        case getType(actions.addCoins):
            return {
                ...state,
                coins: state.coins + action.payload
            };

        case getType(actions.addScore):
            return {
                ...state,
                score: state.score + action.payload
            };

        case getType(actions.addLives):
            return {
                ...state,
                lives: Math.max(0, state.lives + action.payload),
                lastLiveIncrementTimestamp: new Date().getTime()
            };

        case getType(actions.incrementCompletedLevels):
            return {
                ...state,
                levelsCompleted: state.levelsCompleted + 1
            };

        case getType(actions.addBonus):
            return {
                ...state,
                bonuses: {
                    ...state.bonuses,
                    [action.payload.bonus]: (state.bonuses[action.payload.bonus] || 0) + action.payload.count
                }
            };

        case getType(actions.toggleMusic):
            music.mute(state.settings.music);

            return {
                ...state,
                settings: {
                    ...state.settings,
                    music: !state.settings.music
                }
            };

        case getType(actions.toggleSounds):
            sounds.mute(state.settings.sounds);

            return {
                ...state,
                settings: {
                    ...state.settings,
                    sounds: !state.settings.sounds
                }
            };

        case getType(actions.createShortcut.success):
            return {
                ...state,
                settings: {
                    ...state.settings,
                    shortcutCreated: true
                }
            };

        case getType(actions.changeProfile.request):
            return {
                ...state,
                name: action.payload.name || state.name,
                picture: action.payload.picture || state.picture
            };

        default:
            return state;
    }
};
